// ***************
// src/app/services/althutils.js
// autor: WdePaula / MVinfo
// data: 11/7/24 | 14h31
// data: 30/12/24 | 13h01 - eliminamos o localStorage.clear e individualizamos a remoção
// ***************




// import { useNavigate } from "react-router-dom";

export const autoLogout = () => {
    // const navigate = useNavigate(); // Hook para navegação
    // localStorage.clear(); // substituída pelas 3 linhas abaixo 30/12/24w
    localStorage.removeItem("tokenlg");
    localStorage.removeItem("tokenacw");
    localStorage.removeItem("tokenasw");

    window.location.href = "/app/login/cliente";
    // navigate('/login/cliente');
};
